export function sanitizePhone(phone) {
    return (phone || "").toString().replace(/[^0-9]/gi, "")
}